import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum OrderRoutesFormErrorStatesEnum {
    UpdateBrokersFailed = ErrorStateScheduleEnum.PanelOrderRoutesFormErrorStatesStartIndex,
    CreateBrokersFailed,
    UpdateRoutesFailed,
    CreateRoutesFailed,
    UpdateRouteSetFailed,
    CreateRouteSetFailed,
    UpdateStatusFailed
}
